import { CommonUrls } from '../common'
import { URLS as ConfigUrls } from '@/config'

const NEXTERA_BASE_URL = `https://app${ConfigUrls.URL_ENV_CODE}.nexterafarma.com`
const NEXTERA_SESSION_MANAGER_URL = `https://backend${ConfigUrls.URL_ENV_CODE}.nexterafarma.com`
const LOGIN_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/farmacloud/login`
const LOGOUT_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/logout`
const NEXTERA_TOKEN_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/tokens`
const NEXTERA_UPDATE_TOKEN_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/update-jti`
const SHELL_CONFIG_URL = process.env.VUE_APP_SHELL_CONFIG_URL || `${NEXTERA_SESSION_MANAGER_URL}/auth/user/shell-config`
const SETTINGS_CONFIG_URL = process.env.VUE_APP_SETTINGS_CONFIG_LOCAL_URL || `${NEXTERA_SESSION_MANAGER_URL}/auth/user/settings-shell-config`
const REFRESH_TOKEN_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/tokens/env/refresh`
const NEW_TOKEN_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/tokens/env/new`
const HOME_CONFIG_URL = process.env.VUE_APP_HOME_CONFIG_URL || `${NEXTERA_SESSION_MANAGER_URL}/home/widgets`
const HELP_DESK_URL = `${NEXTERA_SESSION_MANAGER_URL}/zendesk/autologin`
const PUBLIC_STORAGE = 'https://public-storage.nexterafarma.com'
const AGREEMENT_CONFIG_URL = `${NEXTERA_SESSION_MANAGER_URL}/auth/user/agreements/config`

export default {
  ...CommonUrls,
  LOGIN_URL,
  LOGOUT_URL,
  NEXTERA_BASE_URL,
  NEXTERA_TOKEN_URL,
  HOME_CONFIG_URL,
  SHELL_CONFIG_URL,
  SETTINGS_CONFIG_URL,
  REFRESH_TOKEN_URL,
  NEW_TOKEN_URL,
  NEXTERA_UPDATE_TOKEN_URL,
  HELP_DESK_URL,
  NEXTERA_SESSION_MANAGER_URL,
  PUBLIC_STORAGE,
  AGREEMENT_CONFIG_URL
}
